import { Trans, useTranslation } from "react-i18next";
import CallbackForm from "./CallbackForm";
import { config, getSupportPhoneNumber } from "../../../../utils/tenantConfig";

export default function Callback() {
	const { t, i18n } = useTranslation("requestCallback");
	const supportPhoneNumber = getSupportPhoneNumber(config, i18n.language);

	return (
		<div className="mx-auto container-max-sm m-4">
			<p className="request-callback-title text-navy-blue">{t("title")}</p>
			<Trans
				t={t}
				i18nKey="description"
				values={{
					supportPhoneNumber,
					tenantDisplayName: config.tenantDisplayName,
				}}
			>
				description
			</Trans>
			<CallbackForm />
		</div>
	);
}
